import React, { useState } from 'react';
import {
  Table as MUITable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  tableCellClasses,
  TablePagination,
  Checkbox
} from '@mui/material';
import Box from '@mui/material/Box/Box';
import CircularProgress from '@mui/material/CircularProgress';

interface TableProps {
  heads: Array<string>;
  count: number;
  page?: number;
  rowsPerPage?: number;
  rowsPerPageOptions?: number[];
  onPageChange?: (event: unknown, newPage: number) => void;
  onRowsPerPageChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectAll?: (checked: boolean) => void;
  selectAll?: boolean;
  children: React.ReactNode;
  isLoading?: boolean;
}

const Table: React.FC<TableProps> = ({
  heads,
  count,
  page = 0,
  rowsPerPage = 10,
  rowsPerPageOptions = [10, 25, 100],
  onPageChange,
  onRowsPerPageChange,
  onSelectAll,
  selectAll,
  children,
  isLoading
}) => {
  if (page * rowsPerPage > count) {
    onPageChange && onPageChange(null, 0);
  }
  const childrenCount = React.Children.count(children);
  const childrenMap = React.Children.map(children, (data) => data);

  return (
    <Paper>
      <TableContainer>
        <MUITable sx={{ minWidth: 650 }} size="medium">
          <TableHead>
            <TableRow>
              {heads.map((head) => (
                <StyledTableCell align="center" key={head}>
                  {head === '$checkbox' ? (
                    <Checkbox
                      color="warning"
                      checked={selectAll}
                      onChange={(_, checked: boolean) => onSelectAll && onSelectAll(checked)}
                      sx={{ padding: 0 }}
                    />
                  ) : (
                    head
                  )}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ position: 'relative', overflow: null }}>
            {isLoading && childrenCount == 1 && childrenMap && childrenMap[0] == '' ? (
              <Box sx={{ height: 60 }} />
            ) : null}
            {children}
            {isLoading ? (
              <Box
                sx={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  top: 0,
                  margin: 'auto',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#fffa',
                  color:"#666"
                }}
              >
                <CircularProgress color="inherit" thickness={7} size={'2rem'} />
              </Box>
            ) : null}
          </TableBody>
        </MUITable>
      </TableContainer>
      {onPageChange ? (
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      ) : null}
    </Paper>
  );
};

export default Table;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white
  }
}));
